(() => {
  'use strict';
  function init(root){
    const compare=root.querySelector('[data-cs-ba-compare]');
    const range=root.querySelector('[data-cs-ba-range]');
    if(!compare||!range||range.dataset.csBaReady==='true') return;
    const update=()=>{
      const value=Math.max(0,Math.min(100,Number(range.value)||50));
      compare.style.setProperty('--cs-ba-position',`${value}%`);
      range.setAttribute('aria-valuenow',String(value));
    };
    range.addEventListener('input',update,{passive:true});
    range.addEventListener('change',update,{passive:true});
    range.dataset.csBaReady='true';
    update();
  }
  function scan(scope=document){scope.querySelectorAll('[data-cs-before-after]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});
  else scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
})();
